var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex bg-light vh-100",style:({
       backgroundImage: 'url(' + 'forklane-signin-background.jpg' + ')'
         })},[_c('div',{staticClass:"bg-light shadow",attrs:{"id":"layout-center"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }